var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "info", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("mcp.introTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("mcp.introBody"))),
          ]),
        ]
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.settingsLoading,
              expression: "settingsLoading",
            },
          ],
          staticClass: "settings-card",
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("mcp.settingsTitle"))),
          ]),
          _c(
            "div",
            { staticClass: "pii-row" },
            [
              _c("div", { staticClass: "pii-text" }, [
                _c("div", { staticClass: "pii-label" }, [
                  _vm._v(_vm._s(_vm.$t("mcp.piiLabel"))),
                ]),
                _c("div", { staticClass: "pii-note" }, [
                  _vm._v(_vm._s(_vm.$t("mcp.piiNote"))),
                ]),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-text": _vm.$t("mcp.piiOn"),
                  "inactive-text": _vm.$t("mcp.piiOff"),
                },
                on: { change: _vm.confirmPii },
                model: {
                  value: _vm.piiEnabled,
                  callback: function ($$v) {
                    _vm.piiEnabled = $$v
                  },
                  expression: "piiEnabled",
                },
              }),
            ],
            1
          ),
          _vm.overrides && (_vm.overrides.forcedOn || _vm.overrides.forcedOff)
            ? _c(
                "div",
                { staticClass: "overrides" },
                [
                  _c(
                    "el-alert",
                    {
                      attrs: {
                        type: "warning",
                        closable: false,
                        "show-icon": "",
                      },
                    },
                    [
                      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(_vm.$t("mcp.overrideTitle"))),
                      ]),
                      _c("div", { staticClass: "intro-body" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("mcp.overrideBody", {
                                on: _vm.overrides.forcedOn,
                                off: _vm.overrides.forcedOff,
                              })
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { size: "mini" },
                          on: { click: _vm.confirmResetPii },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("mcp.resetPii")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "endpoint" }, [
            _c("span", { staticClass: "endpoint-label" }, [
              _vm._v(_vm._s(_vm.$t("mcp.endpoint"))),
            ]),
            _c("code", [_vm._v(_vm._s(_vm.endpoint))]),
          ]),
        ]
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "keys-card",
        },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("mcp.keysTitle")))]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.openCreate },
                },
                [_vm._v(" " + _vm._s(_vm.$t("mcp.newKey")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.keys, border: "", fit: "", size: "mini" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.label"),
                  prop: "label",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.owner"), "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", [_vm._v(_vm._s(row.email || row.userId))]),
                        _c("div", { staticClass: "prefix" }, [
                          _vm._v(_vm._s(row.keyPrefix)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.status"),
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.revokedAt
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("mcp.revoked")))]
                            )
                          : row.expired
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("mcp.expired")))]
                            )
                          : row.isActive
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("mcp.active")))]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("mcp.passive")))]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.expiresAt"), width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.shortDate(row.expiresAt)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.lastUsed"), width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          _vm._s(
                            row.lastUsedAt ? _vm.shortDate(row.lastUsedAt) : "-"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.pii"),
                  width: "190",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "120px" },
                            attrs: {
                              value: row.piiMode,
                              size: "mini",
                              disabled: !!row.revokedAt,
                            },
                            on: {
                              change: (value) => _vm.confirmKeyPii(row, value),
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("mcp.piiInherit"),
                                value: "inherit",
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("mcp.piiForceOn"),
                                value: "on",
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("mcp.piiForceOff"),
                                value: "off",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "effective",
                            class: { on: row.effectivePii },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.effectivePii
                                    ? _vm.$t("mcp.effectiveOn")
                                    : _vm.$t("mcp.effectiveOff")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.calls"),
                  prop: "callCount",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.actions"),
                  width: "110",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        !row.revokedAt
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "mini",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmRevoke(row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("mcp.revoke")))]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.callsLoading,
              expression: "callsLoading",
            },
          ],
          staticClass: "calls-card",
        },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("mcp.callsTitle")))]),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { size: "mini" },
                  on: { click: _vm.fetchCalls },
                },
                [_vm._v(_vm._s(_vm.$t("mcp.refresh")))]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("mcp.callsNote"))),
          ]),
          _vm.totals
            ? _c("div", { staticClass: "totals" }, [
                _c("span", { staticClass: "total-item" }, [
                  _vm._v(_vm._s(_vm.$t("mcp.last7")) + ": "),
                  _c("b", [_vm._v(_vm._s(_vm.totals.total))]),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "total-item",
                    class: { bad: _vm.totals.rejected > 0 },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("mcp.rejected")) + ": "),
                    _c("b", [_vm._v(_vm._s(_vm.totals.rejected))]),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "total-item",
                    class: { warn: _vm.totals.failed > 0 },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("mcp.errors")) + ": "),
                    _c("b", [_vm._v(_vm._s(_vm.totals.failed))]),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "total-item",
                    class: { warn: _vm.totals.withPii > 0 },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("mcp.withPii")) + ": "),
                    _c("b", [_vm._v(_vm._s(_vm.totals.withPii))]),
                  ]
                ),
              ])
            : _vm._e(),
          _c(
            "el-form",
            {
              staticClass: "call-filters",
              attrs: { inline: true, size: "mini" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.fetchCalls.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      clearable: "",
                      placeholder: _vm.$t("mcp.subjectPlaceholder"),
                    },
                    on: { clear: _vm.fetchCalls },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.fetchCalls.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.callFilter.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.callFilter, "subject", $$v)
                      },
                      expression: "callFilter.subject",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { clearable: "", placeholder: _vm.$t("mcp.tool") },
                      on: { change: _vm.fetchCalls },
                      model: {
                        value: _vm.callFilter.toolName,
                        callback: function ($$v) {
                          _vm.$set(_vm.callFilter, "toolName", $$v)
                        },
                        expression: "callFilter.toolName",
                      },
                    },
                    _vm._l(_vm.toolNames, function (t) {
                      return _c("el-option", {
                        key: t,
                        attrs: { label: t, value: t },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.fetchCalls },
                      model: {
                        value: _vm.callFilter.onlyProblems,
                        callback: function ($$v) {
                          _vm.$set(_vm.callFilter, "onlyProblems", $$v)
                        },
                        expression: "callFilter.onlyProblems",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("mcp.onlyProblems")) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchCalls },
                    },
                    [_vm._v(_vm._s(_vm.$t("mcp.search")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { "margin-top": "6px" },
              attrs: { data: _vm.calls, border: "", fit: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticClass: "detail" }, [
                          _c("div", [
                            _c("span", { staticClass: "detail-label" }, [
                              _vm._v(_vm._s(_vm.$t("mcp.arguments"))),
                            ]),
                            _c("code", [
                              _vm._v(_vm._s(_vm.fullArgs(row.arguments))),
                            ]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "detail-label" }, [
                              _vm._v(_vm._s(_vm.$t("mcp.method"))),
                            ]),
                            _vm._v(" " + _vm._s(row.method || "-")),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "detail-label" }, [
                              _vm._v(_vm._s(_vm.$t("mcp.keyPrefix"))),
                            ]),
                            _c("code", [_vm._v(_vm._s(row.keyPrefix || "-"))]),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "detail-label" }, [
                              _vm._v(_vm._s(_vm.$t("mcp.client"))),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(row.clientName || "-") +
                                " " +
                                _vm._s(row.clientVersion || "") +
                                " "
                            ),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "detail-label" }, [
                              _vm._v(_vm._s(_vm.$t("mcp.userAgent"))),
                            ]),
                            _vm._v(" " + _vm._s(row.userAgent || "-")),
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "detail-label" }, [
                              _vm._v("IP"),
                            ]),
                            _vm._v(" " + _vm._s(row.ip || "-")),
                          ]),
                          row.error
                            ? _c("div", [
                                _c("span", { staticClass: "detail-label" }, [
                                  _vm._v(_vm._s(_vm.$t("mcp.error"))),
                                ]),
                                _c("span", { staticClass: "err-text" }, [
                                  _vm._v(_vm._s(row.error)),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.time"), width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.shortDate(row.createdAt)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.owner"), "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.email || row.userId
                          ? _c("span", [
                              _vm._v(_vm._s(row.email || row.userId)),
                            ])
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("mcp.unknownKeyNote"),
                                  placement: "top",
                                },
                              },
                              [
                                _c("span", { staticClass: "unknown" }, [
                                  _vm._v(_vm._s(_vm.$t("mcp.unknownKey"))),
                                ]),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.tool"), "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.toolName || row.method || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("mcp.subject"), "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticClass: "args" }, [
                          _vm._v(_vm._s(row.subject || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.result"),
                  width: "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        !row.authorized
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [_vm._v(_vm._s(_vm.$t("mcp.rejected")))]
                            )
                          : row.ok
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.rowCount === null
                                        ? _vm.$t("mcp.okShort")
                                        : row.rowCount +
                                            " " +
                                            _vm.$t("mcp.rows")
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: row.error || "",
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "warning", size: "mini" } },
                                  [_vm._v(_vm._s(_vm.$t("mcp.failed")))]
                                ),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.pii"),
                  width: "70",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.piiRevealed
                          ? _c("i", { staticClass: "el-icon-view pii-on" })
                          : _c("span", { staticClass: "pii-off" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mcp.duration"),
                  width: "85",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.durationMs) + " ms")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mcp.newKey"),
            visible: _vm.createVisible,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "150px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("mcp.ownerEmail") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "ornek@wewalk.io" },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                  _c("div", { staticClass: "form-note" }, [
                    _vm._v(_vm._s(_vm.$t("mcp.ownerNote"))),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("mcp.label") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("mcp.labelPlaceholder") },
                    model: {
                      value: _vm.form.label,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "label", $$v)
                      },
                      expression: "form.label",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("mcp.validFor") } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 730 },
                    model: {
                      value: _vm.form.expiresInDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "expiresInDays", $$v)
                      },
                      expression: "form.expiresInDays",
                    },
                  }),
                  _c("span", { staticClass: "form-note inline" }, [
                    _vm._v(_vm._s(_vm.$t("mcp.days"))),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("mcp.piiLabel") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      model: {
                        value: _vm.form.piiMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "piiMode", $$v)
                        },
                        expression: "form.piiMode",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("mcp.piiInherit"),
                          value: "inherit",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: _vm.$t("mcp.piiForceOn"), value: "on" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("mcp.piiForceOff"),
                          value: "off",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "form-note" }, [
                    _vm._v(_vm._s(_vm.$t("mcp.piiKeyNote"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("mcp.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.creating },
                  on: { click: _vm.create },
                },
                [_vm._v(_vm._s(_vm.$t("mcp.create")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mcp.keyReadyTitle"),
            visible: _vm.keyVisible,
            width: "620px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.keyVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              type: "warning",
              closable: false,
              "show-icon": "",
              title: _vm.$t("mcp.keyOnceWarning"),
            },
          }),
          _c("div", { staticClass: "key-box" }, [
            _c("code", [_vm._v(_vm._s(_vm.issuedKey))]),
          ]),
          _c(
            "el-button",
            {
              attrs: { size: "mini", icon: "el-icon-document-copy" },
              on: { click: _vm.copyKey },
            },
            [_vm._v(_vm._s(_vm.$t("mcp.copy")))]
          ),
          _c("div", { staticClass: "howto" }, [
            _c("div", { staticClass: "howto-title" }, [
              _vm._v(_vm._s(_vm.$t("mcp.howtoTitle"))),
            ]),
            _c("pre", { staticClass: "howto-code" }, [
              _vm._v(_vm._s(_vm.addCommand)),
            ]),
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.keyVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("mcp.done")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }